// extracted by mini-css-extract-plugin
export default {"TagContainer":"IconTextTag_TagContainer__-bCFz","TagIcon":"IconTextTag_TagIcon__g9iGg"};